import { useUser } from '~/providers/UserProvider';

/**
 * Provides the `userId` of the currently selected user.
 */
// TODO consider moving to UserProvider
export const useUserId = () => {
  const user = useUser();

  return `${user.id}` as const;
};
